import React from 'react';
import { Button } from 'reactstrap';

const FileUploader = ({ handleChange, children }) => {
    // Create a reference to the hidden file input element
    const hiddenFileInput = React.useRef(null);

    // Programatically click the hidden file input element
    // when the Button component is clicked
    const handleClick = () => {
        hiddenFileInput.current.click();
    };
    // Call a function (passed as a prop from the parent component)
    // to handle the user-selected file 
    const handleChangeUpload = event => {
        const fileUploaded = event.target.files[0];

        handleChange(fileUploaded);
    };
    return (
        <React.Fragment>
            <Button onClick={handleClick}>
                {children}
            </Button>
            <input
                type="file"
                ref={hiddenFileInput}
                onChange={handleChangeUpload}
                style={{ display: 'none' }}     
            />
            </React.Fragment>
    );
}
export default FileUploader;